import React from 'react';

export default ({ check, children, wrap }) =>
  check ? wrap({ children }) : children;
